import { render } from "./WIcon.vue?vue&type=template&id=65e12998"
import script from "./WIcon.vue?vue&type=script&lang=js"
export * from "./WIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__